export const dpi = 72;
export const oneInchCm = 2.54;
export const oneInchPt = 72;
export const svgDefaultColor = 'rgb(0, 0, 0)';
